import { render, staticRenderFns } from "./ReportsDeliverySacIvecoPublicView.vue?vue&type=template&id=18767648"
import script from "./ReportsDeliverySacIvecoPublicView.vue?vue&type=script&lang=ts"
export * from "./ReportsDeliverySacIvecoPublicView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports